// An ICD-10 style code at the start of a value: a capital letter, two digits
// and an optional "." with digits, followed by the end of the text or by
// anything but a letter or a digit ("К02.1 Кариес дентина -", "K04",
// "Z01.2"). The letter may be a Cyrillic one that looks Latin: templates and
// speech recognition write the same code in either script. Scribe applies
// the same rule.
const DIAGNOSIS_CODE_START =
  /^\s*[A-ZАВЕКМНОРСТУХ]\d{2}(?:\.\d+)?(?![\p{L}\p{N}]|\.[\p{L}\p{N}])/u;

export const startsWithDiagnosisCode = (text: string) =>
  DIAGNOSIS_CODE_START.test(text);
